/*
 * ********************************************************************
 *  GlobePayroll Confidential
 *
 *  COPYRIGHT ©2016 by GlobePayroll. All Rights Reserved.
 *
 *   NOTICE:  All information contained herein is, and remains the property of GlobePayroll.
 *   The intellectual and technical concepts contained herein are proprietary to GlobePayroll
 *   and may be covered by U.S. and Foreign Patents, patents in process, and are protected by
 *   trade secret or copyright law.
 *   Dissemination of this information or reproduction of this material is strictly forbidden
 *   unless prior written permission is obtained from GlobePayroll.
 *  ********************************************************************
 */

/**
 * Enums utilities
 */
export class Enums {

  /**
   * Applies a function for each values of an enum
   *
   * @param enumObject the enum object to iterate over
   * @param callback the callback to apply
   */
  public static forEachValue<T>(enumObject: any, callback: (value: T) => void) {
    Object.keys(enumObject)
      .map(v => parseInt(v, 10))
      .filter(v => !isNaN(v))
      .forEach(value => callback.call(null, value));
  }

  /**
   * Maps each value of an enum, applying the passed callback
   *
   * @param enumObject the enum to map values of
   * @param callback the callback function that maps values
   * @returns the array of mapped values
   */
  public static mapEachValue<T, U>(enumObject: any, callback: (value: T) => U) {
    return Object.keys(enumObject)
      .map(v => parseInt(v, 10))
      .filter(v => !isNaN(v))
      .map(value => callback.call(null, value));
  }

  public static getNames(e: any) {
    return Object.keys(e).filter(k => isNaN(Number(k)));
  }

}
